import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=4d08a323&"
import script from "./message-text.vue?vue&type=script&lang=js&"
export * from "./message-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports